import React from 'react';

export const CrossCircleIcon = ({ fill = '#05050D' }) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 17C13.1946 17 17 13.1946 17 8.5C17 3.80545 13.1946 0 8.5 0C3.80545 0 0 3.80545 0 8.5C0 13.1946 3.80545 17 8.5 17ZM4.3299 13.872L13.872 4.3299C14.8891 5.6382 15.3934 7.27285 15.2902 8.92675C15.187 10.5806 14.4835 12.14 13.3117 13.3117C12.14 14.4835 10.5806 15.187 8.92675 15.2902C7.27285 15.3934 5.6382 14.8891 4.3299 13.872ZM3.128 12.6701C2.11095 11.3618 1.60663 9.72715 1.70981 8.07325C1.81298 6.41935 2.51653 4.86004 3.68829 3.68829C4.86004 2.51653 6.41935 1.81298 8.07325 1.70981C9.72715 1.60663 11.3618 2.11095 12.6701 3.128L3.128 12.6701Z"
        fill="#05050D"
      />
    </svg>
  );
};
